<!--  -->
<template>
  <div id="Home" style="position: relative;">
    <div class="home_top flex align-center"
      style="position: absolute;left: 50%;transform: translateX(-50%);"
     >
      当前算力
      <div class="home_number margin-left-xs margin-right-xs" v-for="(i,index) in carbonReduction" :key="index">{{i}}</div>
      次/秒
    </div>
  </div>
</template>

<script>

  import { dataInterface } from '@/api/dataInterfaceApi';

  export default {
    name: 'home',
    components: {
    },
    data() {
      return {
        carbonReduction:[],
        currenIndex: 'sctterMap',
      }
    },
	computed: {
	},
    mounted() {
      this.selectComprehensiveSituation()
    },
    methods: {
      changeList(val) {
        if (val.type == this.currenIndex) {
          return
        }
        this.currenIndex = val.type
      },
      getData(data){
        this.selectComprehensiveSituation(data);
      },
      //当前算力

    },
  }
</script>
<style lang="scss" scoped>
  #Home {
    margin-top: 250px;
    width: 100%;
    height: 100%;
    position: relative;
    .select {
      position: absolute;
      left: 1%;
      top: 15%;
      z-index: 15;

      .select_item {
        padding: 6px 25px;
        color: rgb(179, 239, 255);
        background: rgba(147, 235, 248, .35);
        border-radius: 15px;
        margin: 25px 0;
        cursor: pointer;

        .active {
          color: rgb(254, 217, 50);
        }
      }
    }
    .home_top{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0;
      z-index: 15;
      font-size: 32px;
    }
    .home_number{
      width:70px;
      height:76px;
      line-height: 76px;
      font-size:60px;
      font-family: 'DS-Digital-Bold';
      color:#00FDF4;
      text-align: center;
      background-image: linear-gradient(45deg, rgba(35,94,92,0.00) 0%, rgba(69,196,190,0.60) 48%, rgba(36,98,96,0.03) 100%, rgba(35,94,92,0.00) 100%);
      border-radius: 6px;
      border-radius: 6px;
    }
  }
</style>